export const SET_RAW_INGREDIENT_CONFIGURATIONS_MODAL =
	'GLOBAL_ADMINISTRATION_RAW_INGREDIENT_CONFIGURATIONS/SET_RAW_INGREDIENT_CONFIGURATIONS_MODAL';
export const UPDATE_RAW_INGREDIENT_CONFIGURATIONS =
	'GLOBAL_ADMINISTRATION_RAW_INGREDIENT_CONFIGURATIONS/UPDATE_RAW_INGREDIENT_CONFIGURATIONS';
export const RESET_STATE =
	'GLOBAL_ADMINISTRATION_RAW_INGREDIENT_CONFIGURATIONS/RESET_STATE';

export const ADD_BATCH_LIST =
	'GLOBAL_ADMINISTRATION_RAW_INGREDIENT_CONFIGURATIONS/ADD_BATCH_LIST';
export const EDIT_BATCH_LIST_ITEM =
	'GLOBAL_ADMINISTRATION_RAW_INGREDIENT_CONFIGURATIONS/EDIT_BATCH_LIST_ITEM';
export const REMOVE_BATCH_LIST_ITEM =
	'GLOBAL_ADMINISTRATION_RAW_INGREDIENT_CONFIGURATIONS/REMOVE_BATCH_LIST_ITEM';
export const ADD_BATCH_LIST_ITEM_ROW =
	'GLOBAL_ADMINISTRATION_RAW_INGREDIENT_CONFIGURATIONS/ADD_BATCH_LIST_ITEM_ROW';

export function setRawIngredientConfigurationsModal(payload) {
	return {
		type: SET_RAW_INGREDIENT_CONFIGURATIONS_MODAL,
		payload
	};
}
export function updateRawIngredientConfigurations(payload) {
	return {
		type: UPDATE_RAW_INGREDIENT_CONFIGURATIONS,
		payload
	};
}

export function resetState() {
	return {
		type: RESET_STATE
	};
}

export function addBatchList(payload) {
	return {
		type: ADD_BATCH_LIST,
		payload
	};
}

export function editBatchListItem(payload) {
	return {
		type: EDIT_BATCH_LIST_ITEM,
		payload
	};
}

export function removeBatchListItem(payload) {
	return {
		type: REMOVE_BATCH_LIST_ITEM,
		payload
	};
}

export function addBatchListItemRow() {
	return {
		type: ADD_BATCH_LIST_ITEM_ROW
	};
}
